import React, { Component } from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField } from "material-ui"
import strings from "../../../../../localization/strings"

interface IProps {
    open: boolean
    handleClose(): void
    declineCandidateOnJob(declineNote: string): void
}

interface IState {
    note: string
    errorNote: string
}

export default class CandidateDeclineDialog extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            note: "",
            errorNote: "",
        }
        autobind(this)
    }

    checkValidate() {
        let isValidate = true
        if (!this.state.note.trim()) {
          this.setState({ errorNote: strings.This_field_is_required })
          isValidate = false
        }
        else {
          this.setState({ errorNote: "" })
        }
        return isValidate
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                title={strings.Decline}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton label={strings.CANCEL} secondary onClick={() => this.props.handleClose()} />,
                    <FlatButton
                        label={strings.Decline}
                        primary
                        onClick={() => {
                            if (this.checkValidate()) {
                                this.props.declineCandidateOnJob(this.state.note)
                            }
                        }}
                    />
                ]}
            >
                <div style={{ padding: "0px 15px 0px 15px" }}>
                    <TextField
                        floatingLabelText={strings.Give_Reason_To_Decline}
                        value={this.state.note}
                        onChange={(e, value) => { this.setState({ note: value }, () => this.checkValidate()) }}
                        errorText={this.state.errorNote}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                        fullWidth={true}
                        multiLine 
                        rows={3} 
                        rowsMax={4}
                    />
                </div>
            </Dialog>
        )
    }
}